import { axios } from 'lib/axios';
import { toFormData } from './formData';
import { useQnaMutation } from './useQnaMutation';

const answerQuestion = (resource, id, { questionId, ...values }) =>
  axios.put(`/api/${resource}/${id}/qna/questions/${questionId}/answer`, toFormData(values));

export const useAnswerQuestion = (resource, id, onSuccess) =>
  useQnaMutation(resource, id, (values) => answerQuestion(resource, id, values), {
    successMessage: (values) => (values.publish ? 'Answer published' : 'Draft answer saved'),
    onSuccess,
  });
